"use strict";

/* Controllers */
_BannerFlowApp.controller(
    "HeaderController",
    function HeaderController($scope, $rootScope, $state, AuthInfo, Utils) {
        var isInListView = function () {
            return (
                $state.is("root.feeds") ||
                $state.is("root.feeds.folder") ||
                $state.is("root.landingpages") ||
                $state.is("root.landingpages.folder")
            );
        };

        $scope.model = {
            isInListView: isInListView()
        };

        $scope.scrolled = false;

        $scope.goHome = function () {
            Utils.GoHome();
        };

        var stateChangeListener = $rootScope.$on("$stateChangeSuccess", function () {
            $scope.model.isInListView = isInListView();
        });

        $scope.$on("$destroy", function () {
            if (stateChangeListener) stateChangeListener();
        });

        $scope.isEmployee = function () {
            return AuthInfo.LoggedInUser.isEmployee;
        };

        $scope.unreadNews = false;

        $scope.openIntercomNews = function () {
            Intercom("showSpace", "news");
        };
    }
);
